<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

// import UserAuthForm from "./components/UserAuthForm.vue";

const loading = ref(false)
const email = ref('')
const route = useRoute()
const isLogin = computed(() => route.name === 'login')
// import { buttonVariants } from "@/lib/registry/new-york/ui/button";
</script>

<template>
  <div class="md:hidden">
    <VPImage
      alt="Authentification"
      width="1280"
      height="1214"
      class="block"
      :image="{
        dark: '/examples/authentication-dark.png',
        light: '/examples/authentication-light.png',
      }"
    />
  </div>

  <div
    class="container relative h-[800px] flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-2 lg:px-0"
  >
    <router-link
      :to="{ name: !isLogin ? 'login' : 'signup' }"
      class="absolute right-4 top-4 md:right-8 md:top-8"
    >
      <Button variant="outline" size="lg">
        {{ isLogin ? "S'inscrire" : "Se connecter" }}
      </Button>
    </router-link>

    <div
      class="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex"
    >
      <div class="absolute inset-0 bg-ski" />
      <div class="absolute inset-0 bg-purple-900/50" />
      <!-- Added purple overlay -->

      <router-link
        to="/"
        class="relative z-20 flex items-center text-lg font-medium"
      >
        <Logotype variant="light" />
      </router-link>
      <div class="relative z-20 mt-auto">
        <blockquote class="space-y-2">
          <p class="text-5xl">
            Votre coaching, <br>optimisé.
          </p>
          <footer class="text-xl">
            Unissez votre expertise humaine à la puissance de l'IA.
          </footer>
        </blockquote>
      </div>
    </div>
    <div class="lg:p-8">
      <div
        class="mx-auto flex w-full flex-col align-left space-y-6 sm:w-[350px]"
      >
        <div class="flex flex-col space-y-2 text-center">
          <h1 class="text-2xl font-semibold tracking-tight">
            {{ isLogin ? "Bon retour parmi nous !" : "Créez un compte " }}
          </h1>
          <p class="text-sm text-muted-foreground">
            {{
              isLogin
                ? "Connectez-vous à votre compte"
                : "Bienvenue sur Selfwise"
            }}
          </p>
        </div>
        <UserAuthForm />
        <p class="px-8 text-center text-sm text-muted-foreground">
          En cliquant sur continuer, vous acceptez nos

          <a href="/terms" class="underline-offset-4 hover:text-primary">
            Conditions d'utilisation
          </a>
          et notre
          <a href="/privacy" class="underline-offset-4 hover:text-primary">
            Politique de confidentialité</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-ski {
  background: url('https://static.selfwise.io/wiki/assets/img/Image-Background/Format_Web_BG_Selfwise_06-lg.webp')
    no-repeat center center;
  background-size: cover; /* Ensures the image fills the container */
}
</style>
